import React from 'react';
import { BookOpen, Hammer, Trophy, Users, Presentation, TrendingUp } from 'lucide-react';
import { WHY } from './data';

const ICONS = [BookOpen, Hammer, Trophy, Users, Presentation, TrendingUp];
const STYLES = ['bg-[#D7FF38]', 'bg-white', 'bg-[#365CFF] text-white', 'bg-white', 'bg-[#111] text-[#F5F3EB]', 'bg-[#FF6338]'];
const SPAN = ['lg:col-span-2', '', '', '', 'lg:col-span-2', ''];

export const ConvergeWhy = () => (
  <section className="scroll-mt-20 border-b-2 border-[#111]" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em]">[ 06 ] Why attend</p>
      <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-[2.3rem] sm:text-7xl break-words">Why CONVERGE?</h2>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY.map(([title, text], i) => {
          const Icon = ICONS[i];
          return (
            <article key={title} className={`border-2 border-[#111] shadow-[5px_5px_0_#111] p-6 cv-lift ${STYLES[i]} ${SPAN[i]}`} data-testid={`why-card-${title.toLowerCase().replace(' ', '-')}`}>
              <div className="flex items-center justify-between">
                <span className="text-xs font-extrabold">{String(i + 1).padStart(2, '0')}</span><Icon size={22} />
              </div>
              <h3 className="cv-display text-xl xl:text-2xl font-extrabold uppercase mt-10 break-words">{title}</h3>
              <p className="mt-2 text-sm font-medium">{text}</p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
